import { useDispatch, useSelector } from "react-redux";

import useAPI from "hooks/useAPI";
import { logout, setTempSessionId, setUser } from "redux/slices/auth";
import shortid from "shortid";
import { useHistory } from "react-router-dom";
import useSelection from "hooks/useSelection";

const useAccount = () => {
  const dispatch = useDispatch();
  const { API } = useAPI({});
  const history = useHistory();
  const { clearBooking } = useSelection({});

  return {
    userIsLoggedIn: (user) => {
      console.log("testing user", user);
      if (user?._id) {
        return true;
      } else {
        return false;
      }
    },
    userHasMandatoryDetails: (user) => {
      //Check if we're missing any mandatory details
      const mandatoryDetails = ["name", "mobileNumber", "dob"];
      const missingMandatoryDetails = mandatoryDetails.filter(
        (detail) => !user[detail] || user[detail] === ""
      );
      return missingMandatoryDetails.length === 0;
    },
    getAndSetUser: async () => {
      console.log("useAccount -> getAndSetUser");
      try {
        const data = await API.get(`/user`);
        console.log("Setting user", data.user);
        dispatch(setUser({ user: data.user }));
        return data.user;
      } catch (error) {
        console.log("error: ", error);
      }
    },
    logout: async () => {
      try {
        await API.get(`/user/logout`);
        dispatch(logout({}));
        clearBooking();
        history.push("/");
      } catch (error) {
        console.log("error: ", error);
      }
    },
  };
};

export default useAccount;
